const isDev = process.env.NODE_ENV !== 'production'

export function logError(message, ...optionalParams) {
  if (!isDev) {
    return
  }
  // eslint-disable-next-line no-console
  console.error(message, ...optionalParams)
}

export function logWarn(message, ...optionalParams) {
  if (!isDev) {
    return
  }
  // eslint-disable-next-line no-console
  console.warn(message, ...optionalParams)
}

export function logDebug(message, ...optionalParams) {
  if (!isDev) {
    return
  }
  // eslint-disable-next-line no-console
  console.debug(message, ...optionalParams)
}

